import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeftOutlined";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRightOutlined";
import React from "react";
import ContentEditable from "react-contenteditable";
import styled from "styled-components";
import { List } from "../../../assets/icons";
import TextView from "../../TextView";

const Wrapper = styled.div`
  width: 100vw;
  padding: 0px 24px 0px 24px;
  gap: 20px;
  height: 50px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: ${({ hasSelectedArc }) =>
    hasSelectedArc ? "auto auto auto" : "auto auto"};
  grid-gap: 20px;
`;

export default function InfoHeader({
  wheelName,
  onClickNext,
  onClickPrev,
  toggleSegmentList,
  onBack,
  selectedArc,
}) {
  return (
    <Wrapper>
      <Row>
        <ArrowBackIcon onClick={onBack} />
        <TextView variant="title"  style={{WebkitLineClamp: 1 }}><ContentEditable html={wheelName} disabled/></TextView>
      </Row>
      <Row hasSelectedArc={selectedArc}> 
        <List onClick={toggleSegmentList} />
        {selectedArc && (
          <>
            <ArrowCircleLeftIcon
              style={{ width: 24, height: 24 }}
              onClick={onClickPrev}
            />
            <ArrowCircleRightIcon
              style={{ width: 24, height: 24 }}
              onClick={onClickNext}
            />
          </>
        )}
      </Row>
    </Wrapper>
  );
}
